module.exports = __webpack_public_path__ + "img/businessman-is-stacking.430cf978.png";